import {useState} from 'react';
import './portfolio.css';

import { motion } from "framer-motion";
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';


import ImageListItem from '@mui/material/ImageListItem';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import ListSubheader from '@mui/material/ListSubheader';
import IconButton from '@mui/material/IconButton';
import InfoIcon from '@mui/icons-material/Info';
import { Repeat } from '@mui/icons-material';



const images = [
  {
    src: 'res/images/myportpoliodesign/portfolio-image (62).png',
    alt: 'Image 1',
    description: 'User Management Dashboard',
  },

  

  {
    src: 'res/images/myportpoliodesign/portfolio-image (78).jpg',
    alt: 'Image 2',
    description: 'TV Derana Website Redesign',
  },

  {
    src: 'res/images/myportpoliodesign/portfolio-image (6).png',
    alt: 'Image 2',
    description: 'COCO Pet App UI Concept',
  },
  {
    src: 'res/images/myportpoliodesign/portfolio-image (74).png',
    alt: 'Image 2',
    description: 'Project Management Dashboard',
  },{
    src: 'res/images/myportpoliodesign/portfolio-image (7).png',
    alt: 'Image 2',
    description: 'Babycare App',
  },{
    src: 'res/images/myportpoliodesign/portfolio-image (52).png',
    alt: 'Image 2',
    description: 'Food Delivery App UI',
  },{
    src: 'res/images/myportpoliodesign/portfolio-image (1).png',
    alt: 'Image 2',
    description: 'Logo design',
  },{
    src: 'res/images/myportpoliodesign/portfolio-image (15).png',
    alt: 'Image 2',
    description: 'Taxi App UI Design',
  },{
    src: 'res/images/myportpoliodesign/portfolio-image (16).png',
    alt: 'Image 2',
    description: 'Taxi App UI Design',
  },{
    src: 'res/images/myportpoliodesign/portfolio-image (17).png',
    alt: 'Image 2',
    description: 'Taxi App UI Design',
  },{
    src: 'res/images/myportpoliodesign/portfolio-image (35).png',
    alt: 'Image 2',
    description: 'Taxi App UI Design',
  },{
    src: 'res/images/myportpoliodesign/portfolio-image (38).png',
    alt: 'Image 2',
    description: 'Taxi App UI Design',
  },{
    src: 'res/images/myportpoliodesign/portfolio-image (46).png',
    alt: 'Image 2',
    description: 'Taxi App UI Design',
  },{
    src: 'res/images/myportpoliodesign/portfolio-image (49).png',
    alt: 'Image 2',
    description: 'Taxi App UI Design',
  },{
    src: 'res/images/myportpoliodesign/portfolio-image (61).png',
    alt: 'Image 2',
    description: 'Taxi App UI Design',
  },{
    src: 'res/images/myportpoliodesign/portfolio-image (60).png',
    alt: 'Image 2',
    description: 'Taxi App UI Design',
  },{
    src: 'res/images/myportpoliodesign/portfolio-image (70).png',
    alt: 'Image 2',
    description: 'Taxi App UI Design',
  },{
    src: 'res/images/myportpoliodesign/portfolio-image (55).png',
    alt: 'Image 2',
    description: 'Taxi App UI Design',
  },{
    src: 'res/images/myportpoliodesign/portfolio-image (43).png',
    alt: 'Image 2',
    description: 'Taxi App UI Design',
  },{
    src: 'res/images/myportpoliodesign/portfolio-image (21).png',
    alt: 'Image 2',
    description: 'Taxi App UI Design',
  },

  // Add more images as needed
];

 
const Portfolio = () => {


  
  return (
    <section className="" id="portfolio">
      <h5>The</h5>
      <h2>Portfolio</h2>
    
      <Box sx={{ p: 3}}>
      <ImageList
      sx={{ width: '100%', maxHeight: '80vh', gridTemplateColumns: 'repeat(3, 1fr) !important',}}
    >
  
      {images.map((item) => (
        <ImageListItem key={item.src}   >
          <img
            srcSet={`${item.src}?w=248&fit=crop&auto=format&dpr=3 3x`}
            src={`${item.src}?w=248&fit=crop&auto=format`}
            alt={item.description}
            loading="lazy"
         
           
          />
          <ImageListItemBar
            title={item.description}
          />
        </ImageListItem>
      ))}
    </ImageList>
</Box>


  
      <div className="behance-link">
          <motion.a
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.8 }}
            href="https://www.behance.net/praveenpremasinghe"
            className="btn btn-primary"
          >
            Check Out My Behance
          </motion.a>
        </div>
    </section>


    
  )
};

export default Portfolio;